export const ja = {
  Global: {
    save: '保存',
    savingInProgress: 'Saving in progress JA',
    edit: '編集',
    amend: 'Amend JA',
    editProposal: 'Edit proposal JA',
    delete: '削除',
    cancel: 'キャンセル',
    confirm: '確認',
    proceed: '続行',
    assign: '割当A',
    submit: '提出',
    comment: 'Comment JA',
    accepted: '受け入れた',
    denied: '拒否された',
    deny: '拒否する',
    done: '完了',
    notDone: '未完了',
    started: '始めました', 
    notRelevant: '関係無し',
    noInfo: '情報無',
    addComment: 'コメントを追加',
    noComments: 'コメント無し',
    start: '開始',
    end: '終了',
    pending: '保留中',
    approve: '承認する',
    approved: '承認済み',
    notApproved: '未承認',
    release: 'リリースする',
    released: 'リリース済み',
    notReleased: 'リリースされていない',
    reopen: '再開',
    requestedBy: '要求者:',
    requestedAt: '要求日:',
    proposedDecision: '提案された決定',
    proposedCategory: '提案されたカテゴリー',
    proposedSubcategory: 'Proposed subcategory',
    search: '検索',
    noResults: '結果なし',
    upload: 'アップロード',
    uploading: 'アップロード中',
    noFilesUploaded: 'アップロードされたファイルはありません',
    close: '閉じる',
    back: '戻る',
    next: '次へ',
    unknown: '不明',
    from: 'から',
    to: 'まで',
    logout: 'ログアウト',
    profile: 'プロフィール',
    group: 'グループ',
    code: 'コード',
    confirmationDialogTitle: '確認要',
    confirmDeleteFileDialogContent: 'このファイルを削除してもよろしいですか',
    report: '報告する',
    unsavedAnswers: '保存されていない回答があります。確認のボタンをクリックすると、保存されていない全てのデータが失われます。',
    unsavedAnswersActionMode: '保存されていない回答があります。 保存しますか？',
    noOptions: 'オプションなし',
    actionMode: 'アクションモード',
    reason: '理由',
    optional: 'オプショナル',
    choose: '選ぶ',
    serialNumberMissing: 'Serial number missing JA',
    recipientEmails: 'Recipient Emails (one address per line) JA',
    DatePicker: {
      cancelLabel: 'キャンセル',
      okLabel: 'OK',
      minDateMessage: '入力した日付以降の日付の入力が必要です。',
      maxDateMessage: '入力した日付以前の日付の入力が必要です。',
      invalidDateMessage: '無効な日付形式',
    },
    Errors: {
      authErrorTitle: '認証エラー',
      authErrorParagraph1: 'このアプリにアクセスする権限がありません。',
      authErrorParagraph2: '管理者に連絡してください。',
      authErrorParagraph3: 'または、Active Directoryからログアウトして、再試行してください。',
      pageNotFound: 'ページが見つかりません。',
      pageNotFoundParagraph1: 'このページが見つかりません。',
      back: 'ホーム',
      rotateDevice: 'デバイスを回転させてください。',
    },
    Feedback: {
      error: 'エラーが発生しました...アクションに失敗しました。',
      authentication: '認証中です。しばらくお待ちください。',
      success: 'アクションは正常に完了しました。',
      limitReached: '商業的承認上限に達しました。',
      requestHasBeenSentToApprover: 'リクエストが承認者に送信されました',
      noQuestions: '選択された製品ファミリーにない質問です。',
      decisionNotSend: '決定は正常にSAPに送信されませんでした。',
      noLimitForCC: 'このCCの商業的承認権限がありません。',
      jobCostDoesNotExist:'SAPジョブのジョブコストがPARSデータベースに存在しません。',
      materialNumberBrandDoesNotExist: ' 資料番号ブランドが存在しません。',
      jobIsLocked: 'ジョブはロックされています。',
      noPicturesAreUploaded: '写真がアップロードされていません',
      rateIsProvided: 'レートは正常に登録されました。',
      rateHasToBeDifferent: 'レート決定は以前のものとは異なる必要があります。',
    },
    Status: {
      title: 'ステータス',
      awaitingEquipment: '未着の設備',
      equipmentReceivedWithDocumentation: '書類添付済みの設備',
      jobReleased: 'ジョブリリース',
      productEvaluation: '製品の評価済み',
      strippedAndDecontaminated: '分解、洗浄済み',
      builtAndTested: '組み立て、テスト済み',
      shipped: '出荷済み',
      technicalAndCommercialDecision: '技術的および商業的決定',
      finalReportReleased: '最終報告書がリリース',
      closed: '終了済み',
      productInvestigation: '製品調査',
      customerHold: '顧客保留',
      notStarted: '未開始',
    },
    Roles: {
      RECEIVING: '受け入れ',
      SERVICE_ENGINEER: 'サービスエンジニア',
      FAILURE_ANALYSIS_ENGINEER: 'FAエンジニア',
      SENIOR_FAILURE_ANALYSIS_ENGINEER: 'シニアFAエンジニア',
      FAILURE_ANALYSIS_MANAGER: 'FAマネージャー',
      SERVICE_TECHNOLOGY_CENTER_MANAGER: 'STCマネージャー',
      QUALITY_MANAGER: '品質管理者',
      SERVICE_TECHNICAL_SUPPORT_TEAM: 'サービステクニカルサポートチーム',
      PRODUCT_COMPANY_TECHNICAL_SUPPORT_TEAM: 'PCテクニカルサポートチーム',
      DIVISION_OR_BUSINESS_AREA: '部門や事業領域',
      CUSTOMER_CENTER: 'カスタマーセンター',
      CUSTOMER: '顧客',
      CUSTOMER_CENTER_SERVICE_ENGINEER: 'CCサービスエンジニア',
      SENIOR_CUSTOMER_CENTER_SERVICE_ENGINEER: 'Senior customer center service engineer JA',
      SUPERADMIN: 'Superadmin',
      ZONE_LEADER: 'ゾーンリーダー',
      QUESTION_ADMIN: 'Question admin',
      DISTRIBUTOR: '代理店',
    },
    Permissions: {
      VIEW_JOB: 'ジョブの参照',
      EDIT_JOB: 'ジョブの編集',
      IMPORT_JOB_FROM_SAP: 'SAPからジョブのインポート',
      LEVEL_3_RELEASE_FOR_INVESTIGATION: '調査のためのレベル3のリリース',
      LEVEL_4_RELEASE_FOR_INVESTIGATION: '調査のためのレベル4のリリース',
      GENERATE_AND_DOWNLOAD_REPORT: 'レポートを生成し、ダウンロード',
      VIEW_LOG: 'ログの参照',
      VIEW_CONVERSATION: '会話の参照',
      PARTICIPATE_IN_CONVERSATION: '会話に参加',
      TAG_INTEREST: 'お気に入りに追加',
      ADD_REMOVE_FROM_TEAM: 'チームに追加、削除',
      CREATE_JOB: 'ジョブの作成',
      DELETE_JOB: 'ジョブの削除',
      REQUEST_DIFFERENT_REPORT_LEVEL: '別のレポートレベルを要求',
      APPROVE_DIFFERENT_REPORT_LEVEL: '別のレポートレベルを承認',
      WARRANTY_DECISION: '保証の決定',
      GOODWILL_DECISION: 'GOODWILL の決定',
      LEVEL_1_REPORT_APPROVAL: 'レベル1レポートの承認A',
      LEVEL_2_REPORT_APPROVAL: 'レベル2レポートの承認',
      LEVEL_3_REPORT_APPROVAL: 'レベル3レポートの承認',
      LEVEL_4_REPORT_APPROVAL: 'レベル4レポートの承認',
      LEVEL_1_REPORT_REOPEN: 'Level 1 report reopen JA',
      LEVEL_2_REPORT_REOPEN: 'Level 2 report reopen JA',
      LEVEL_3_REPORT_REOPEN: 'Level 3 report reopen JA',
      LEVEL_4_REPORT_REOPEN: 'Level 4 report reopen JA',
      REOPEN_REPORT: 'レポートの再開',
      REQUEST_FAILED_PARTS: '不具合部品の要求',
      SHIP_FAILED_PARTS: '不具合部品の出荷',
      PRINT_INPUT_SHEETS: '入力シートの印刷',
      ADMINISTRATE_QUESTIONS: '質問を管理する',
      ADMINISTRATE_DATA: 'データを管理する',
      DOWNLOAD_PICTURES: 'Download pictures JA',
      REQUEST_TECHNICAL_WARRANTY_DECISION: 'Request technical warranty decission JA',
      AMEND_APPROVED_TECHNICAL_DECISION: 'Amend approved technical decision JA',
      AMEND_APPROVED_COMMERCIAL_DECISION: 'Amend approved commercial decision JA',
      ADD_INITIAL_WARRANTY_CODE: 'Add initial warranty code JA',
      RECLASSIFY_TECHNICAL_WARRANTY_CATEGORY: 'Reclassify technical warranty category JA',
      APPROVE_REPORT_LEVEL_4_DOWNGRADE: 'Approve report level 4 downgrade JA',
    },
    Alerts: {
      noAlerts: 'アラートなし',
      healthAndSafetyInformationMissing: '安全確認書の未添付',
      jobNotReleased: 'ジョブはリリースされていません',
      noRecentStatusChange: '最近のステータス変更なし',
      noServiceTechnicalSupportInvolvement: 'サービステクニカルサポートの関与なし',
      noProductCompanyTechnicalSupportInvolvement: '製品会社のテクニカルサポートの関与なし',
      noTechnicalWarrantyDecision: '技術的な保証の未決定',
      noCommercialDecision: '商業的決定の未決定',
      reportNotApproved: '承認されていないレポート',
    },
    Actions: {
      ADD_JOB: '追加されたジョブ',
      IMPORT_JOB: 'SAPからインポートされたジョブ',
      DELETE_JOB: '削除されたジョブ',
      VERIFY_JOB: '確認済みのジョブ',
      SET_PRICE: '編集されたジョブ - 価格',
      ADD_TEAM_MEMBER: 'チームのメンバーの追加',
      REMOVE_TEAM_MEMBER: 'チームのメンバーの削除',
      REQUEST_REPORT_LEVEL_CHANGE: '要求されたレポートレベルの変更',
      APPROVE_REPORT_LEVEL_CHANGE: '承認されたレポートレベルの変更',
      DENY_REPORT_LEVEL_CHANGE: '却下されたレポートレベルの変更',
      REQUEST_REPORT_APPROVAL: '要求されたレポートの承認',
      APPROVE_REPORT_APPROVAL: '承認されたレポートの承認',
      DENY_REPORT_APPROVAL: '却下されたレポートの承認',
      SET_WARRANTY_START_DATE: '編集されたジョブ - 保証期間開始日',
      SET_WARRANTY_END_DATE: '編集されたジョブ - 保証期間終了日',
      EQUIPMENT_SERIAL_NUMBER_EDITED: '編集されたジョブ - 設備の製品番号',
      MATERIAL_NUMBER_EDITED: '編集されたジョブ -  品目番号',
      WORKED_ON_JOB: '編集されたジョブ -  フォーム更新',
      UPLOADED_FILE_ON_JOB: '編集されたジョブ -  アップロードされたファイル',
      REQUEST_TECHNICAL_WARRANTY_DECISION: '要求された技術的な保証の決定',
      APPROVE_TECHNICAL_WARRANTY_DECISION: '承認された技術的な保証の決定',
      DENY_TECHNICAL_WARRANTY_DECISION: '却下された技術的な保証の決定',
      REQUEST_COMMERCIAL_WARRANTY_DECISION: 'Requested commercial warranty decision',
      APPROVE_COMMERCIAL_WARRANTY_DECISION: '承認された商業的な保証の決定',
      NULLIFY_COMMERCIAL_WARRANTY_DECISION: '取り消された商業的な保証の決定',
      DENY_COMMERCIAL_WARRANTY_DECISION: '商業保証判断の否認',
      SEND_COMMENT: 'コメントが追加された',
      REOPEN_REPORT: '編集されたジョブ - レポートの再開',
      AWAITING_EQUIPMENT_STATUS_SET: '編集された状態 - 未着設備のセット',
      AWAITING_EQUIPMENT_STATUS_RESET: '編集された状態 - 未着設備のリセット',
      EQUIPMENT_RECEIVED_WITH_DOCUMENTATION_STATUS_SET: '編集された状態 - 書類添付済み設備のセット',
      EQUIPMENT_RECEIVED_WITH_DOCUMENTATION_STATUS_RESET: '編集された状態 - 書類添付済み設備のリセット',
      JOB_RELEASED_STATUS_SET: '編集された状態 - ジョブリリースのセット',
      JOB_RELEASED_STATUS_RESET: '編集された状態 - ジョブリリースのリセット',
      PRODUCT_EVALUATION_STATUS_SET: '編集された状態 - 製品評価のセット',
      PRODUCT_EVALUATION_STATUS_RESET: '編集された状態 - 製品評価のリセット',
      PRODUCT_INVESTIGATION_STATUS_SET: '編集された状態 - 製品調査のセット',
      PRODUCT_INVESTIGATION_STATUS_RESET: '編集された状態 - 製品調査のリセット',
      STRIPPED_AND_DECONTAMINATED_STATUS_SET: '編集された状態 - 分解、洗浄のセット',
      STRIPPED_AND_DECONTAMINATED_STATUS_RESET: '編集された状態 - 分解、洗浄のリセット',
      BUILT_AND_TESTED_STATUS_SET: '編集された状態 - 組み立て、テストのセット',
      BUILT_AND_TESTED_STATUS_RESET: '編集された状態 - 組み立て、テストのリセット',
      SHIPPED_STATUS_SET: '編集された状態 - 出荷のセット',
      SHIPPED_STATUS_RESET: '編集された状態 - 出荷のリセット',
      TECHNICAL_AND_COMERCIAL_DECISION_STATUS_SET: '編集された状態 - 技術的および商業的決定のセット',
      TECHNICAL_AND_COMERCIAL_DECISION_STATUS_RESET: '編集された状態 - 技術的および商業的決定のリセット',
      FINAL_REPORT_RELEASED_STATUS_SET: '編集された状態 - 最終レポートリリースのセット',
      FINAL_REPORT_RELEASED_STATUS_RESET: '編集された状態 - 最終レポートリリースのリセット',
      CLOSED_STATUS_SET: '編集された状態 - クローズのリセット',
      CLOSED_STATUS_RESET: '編集された状態 - クローズのリセット',
      CUSTOMER_HOLD_STATUS_SET: '編集された状態 - 顧客アクション待ちのセット',
      CUSTOMER_HOLD_STATUS_RESET: '編集された状態 - 顧客アクション待ちのリセット',
      REFACTOR_TECHNICAL_WARRANTY_DECISION: '編集された技術決定カテゴリー',
      GENERATE_ALERT: '生成されたアラート',
      INITIAL_WARRANTY_CODE_EDITED: '最初の保証コードが変更されました',
      AMEND_APPROVED_TECHNICAL_DECISION: 'Amended approved technical warranty decision JA',
      AMEND_APPROVED_COMMERCIAL_DECISION: 'Amended approved commercial decision JA',
      DELETE_APPROVED_TECHNICAL_DECISION: 'Deleted aproved technical warranty decision JA',
      DELETE_APPROVED_COMMERCIAL_DECISION: 'Deleted approved commercial decision JA',
      CHOOSE_RELEASE_METHOD: 'Chose release method JA',
    },
    TechnicalWarranty: {
      ACCEPTED: '認められた',
      DENIED: '拒否された',
      AGREE: ' 同意する',
      DISAGREE: ' そう思わない',
      MANUFACTURING: '製造',
      DESIGN: 'デザイン',
      VENDOR: '販売元',
      PROCESS: 'プロセス',
      INHOUSE_REPAIR: 'In-house修理',
      FIELD_SERVICE_REPAIR: 'フィールドサービス修理',
      REFURBISHED_MATERIAL: 'Refurbished material (service division)',
      NO_FAULT_FOUND: '異常なし',
      WARRANTY_EXPIRED: '保証期間切れ',
      WARRANTY_EXPIRED_NO_FAULT_FOUND: 'Out of standard warranty period - No fault found',
      WARRANTY_EXPIRED_CUSTOMER_FAULT: 'Out of standard warranty period - Customer fault',
      WARRANTY_EXPIRED_OTHER: 'Out of standard warranty period - Other',
      WARRANTY_EXPIRED_COMPONENT_ISSUE: 'Out of standard warranty period - Component issue (Edwards fault)',
      CUSTOMER_FAULT: '顧客の過失',
      OTHER: '他',
      AGREE_WITH_TECHNICAL_WARRANTY_LOG: '技術的な決定に同意する',
      DISAGREE_WITH_TECHNICAL_WARRANTY_LOG: '技術的な決定に同意しない',
      SPARE_PART: 'Spare part (Service Division) JA',
    },
    CommercialWarranty: {
      CONTRACTUAL_AGREEMENT: '契約上の合意',
      GOODWILL_ACCEPTED: 'GOODWILL 承認済み',
      CHARGEABLE_TO_CUSTOMER: '有償',
      EXTENDED_WARRANTY: '延長保証',
      SERVICE_CONTRACT: 'Service contract JA',
      OTHER: '他',
      SEMICONDUCTOR: 'Semiconductor',
      SCIENTIFIC: 'Scientific',
      INDUSTRIAL: 'Industrial',
      SEMICONDUCTOR_SERVICE: 'Semiconductorサービス',
      VACUUM_TECHNIQUE_SERVICE: 'VTS',
      SEMICONDUCTOR_CHAMBER_SOLUTIONS: 'Semiconductor Chamber Solutions',
      SEMI_ABATEMENT_AND_INTEGRATED_SYSTEMS: 'Semi Abatement & integrated systems',
      SEMI_ADVANCED_CHEMICAL_MANAGEMENT: 'Semi Advanced Chemical Management',
      SERVICE_CRYOGENICS: 'Service Cryogenics',
      SEMI_DRY_PUMPS: 'Semi Dry Pumps',
      INDUSTRIAL_CUSTOM_DESIGN: 'Industrial custom design',
      INDUSTRIAL_VACUUM: 'Industrial Vacuum',
      SCIENTIFIC_CUSTOM_DESIGN: 'Scientific custom design',
      SEMICON_TURBO_PUMPS: 'Semicon Turbo pumps',
      POLYCOLD: 'Polycold',
      SCIENTIFIC_CC: 'Scientific Cooling and Cryo',
      SCIENTIFIC_MI: 'Scientific Measurement and Instrumentation',
      SCIENTIFIC_VG: 'Scientific Vacuum Generation'
    },
    Release: {
      NO_TECHNICAL_TEAM_INVOLVEMENT: '技術的なチームの関与無し',
      GOLDENEYE_UPLINK: 'GoldenEyeアップリンク',
      ON_SITE_PRESENCE: '現地訪問',
      RETURN_TO_PRODUCT_COMPANY: 'PCへ返却',
      SEND_BACK_PARTS: 'パーツの返却',
    },
    Forms: {
      fields: {
        basicInformation: '基本情報',
        customerCenter: 'CC',
        serviceTechnologyCenter: 'STC',
        reportLevel: 'レポートレベル',
        initialWarrantyCode: '最初の保証',
        technicalDecision: '技術的な決定',
        commercialDecision: '商業的決定',
        price: '価格',
        jobStatus: 'ジョブのステータス',
        reportCompletion: 'レポートの完了',
        alerts: 'アラート',
        team: 'チーム',
        customer: '顧客',
        customerContact: '顧客の連絡先',
        jobDetails: 'ジョブの詳細',
        jobType: 'ジョブタイプ',
        serviceProduct: 'サービス製品',
        equipment: '機器',
        failure: '不具合',
        symptom: '症状',
        address: '住所A',
        contactPerson: '連絡窓口',
        email: 'メールアドレス',
        phone: '電話番号',
        customerPurchaseOrderNumber: 'お客様発注番号',
        equipmentWarranty: '設備保証',
        serviceWarranty: 'サービス保証',
        reportStatus: 'レポートのステータス',
        reopen: '再開',
        releaseJob: 'リリースジョブ',
        notifyTeam: 'Notify team JA',
      },
      errors: {
        required: 'フィールドは必須項目です。',
        phone: '有効な電話番号を入力して下さい。',
        email: '正しいメールアドレスを入力してください。',
        number: '数字のみ使用できます。',
        alphanumeric: '特殊文字は使用できません。',
        text: '有効な値を入れてください',
        unknown: '問題が発生しました。',
        belowZero: '入力できる最小値は 0.',
        uploadFailed: 'アップロードできませんでした。',
        maxFileSize: '許可される最大サイズは',
        maxLength: maxLength => `許可される最大文字数$${maxLength}`,
        minLength: minLength => `少なくとも${minLength}文字を入力してください。`,
      },
    },
    FaultCodes: {
      fallbackDescription: 'このコードの説明はありません',
      jobTypeDescription: {
        'JT001': 'ジョブタイプJTの説明 JT001',
        'JT002': 'ジョブタイプJTの説明 JT002',
      },
      faultCodeDescription: {
        'FC001': '故障コードFCの説明 FC001',
        'FC002': '故障コードFCの説明 FC002',
      },
      symptomCodeDescription: {
        'SC001': '症状コードSCの説明 SC001',
        'SC002': '症状コードSCの説明 FC002',
      },
    },
    Progress: {
      title: '進捗',
      productReceived: '製品受入',
      productEvaluation: '製品評価',
      stripObservation: '分解観察',
      technicalInvestigation: '技術的な調査',
      conformityTest: '適合性テスト',
    },
  },
  Profile: {
    title: 'プロフィール',
    name: '名前',
    role: '役割',
    company: '会社',
    rights: '権限',
    linked: 'ユーザーは次にリンクされています;',
  },
  Jobs: {
    title: 'ジョブ',
    filters: 'フィルター',
    myJobs: '担当ジョブ',
    otherJobs: '他のジョブ',
    noJobsToDisplay: '表示するジョブはありません',
    pleaseUseTheSearchBar: "Please use the search bar. JA",
    id: 'ID',
    createdAt: '作成日：',
    status: 'ステータス',
    customer: '顧客',
    serialProductNumber: 'サービス製品番号',
    materialNumber: '品目番号',
    equipmentSerialNumber: '設備s。 nr',
    customerCenterPlantCode: 'CCプラントコード',
    serviceTechnologyCenterPlannerGroup: 'STCプランナーグループA',
    handledBy: '担当者：',
    materialDescription: '品目の説明',
    customerName: '顧客名',
    receivedDate: '受け取った日付',
    customerCenterName: 'CC名',
    reportLevel: 'レポートレベル',
    productReceived: '受け取った製品',
    productEvaluation: '製品評価',
    stripObservation: '分解観察',
    technicalInvestigation: '技術的な調査',
    conformityTest: '適合性テスト',
    workFlow: 'ワークフロー',
    analysisFlow: '分析フロー',
    notificationNumber: '通知番号',
    serviceOrderNumber: '指図番号',
  },
  Job: {
    editButton: '編集',
    progress: '進捗',
  },
  Filters: {
    filtersTitle: 'フィルター',
    applyButton: '適用',
    clearButton: '削除',
    sorting: 'ソート',
    sortNew: '新しい順にソート',
    sortOld: '古い順にソート',
    date: '日付',
    dateFrom: 'から',
    dateTo: 'に',
    reportLevel: 'レポートレベル',
    status: '状態',
    customerNumber: '顧客番号',
    customerName: '顧客名',
    serviceProductNumber: 'サービスプロダクト番号',
    materialNumber: '品目番号',
    equipmentSerialNumber: '設備シリアル番号',
    stcPlannerGroup: 'STCプランナーグループ',
    selectstcPlannerGroup: 'STCプランナーグループを選択',
    CCplant: 'CCプラント',
    selectCCplant: 'CCプラントを選択',
    distributor: '代理店',
    selectDistributor: '代理店を選択',
    failureAnalysisEngineerNotAssigned: 'FAエンジニア未特定',
    openedJobs: 'オープンされたJOB',
    publishedJobs: '公開されたJOB',
    pendingMyApproval: '承認待ち',
    notificationNumber: '通知番号',
    unreadMessages: '未読メッセージ',
    serviceOrderNumber: '指図番号',
  },
  AddJob: {
    formSections: {
      title: '新しいジョブを追加',
      createdAt: '作成日',
      button: '保存',
      basicInformation: {
        title: '基本情報',
        fieldLabels: {
          equipmentSerialNumber: '設備シリアル番号',
          serviceTechnologyCenter: 'STC',
          customerCenter: 'CC',
          reportLevel: 'レポートレベル',
          initialWarrantyCode: '最初の保証',
          customerPurchaseOrderNumber: '顧客注文番号',
          responsibleSalesPerson: '担当営業',
          customerCenterContactName: 'CC担当者名',
          customerCenterContactEmail: 'CC担当者のメールアドレス',
        }
      },
      jobType: {
        title: 'タイプ',
        fieldLabels: {
          jobType: 'タイプ',
          jobTypeDescription: '説明',
        },
      },
      searchMaterialNumber: '品目番号を検索',
      materialNumber: {
        title: '品目番号',
        fieldLabels: {
          materialNumber: '品目番号',
          materialNumberDescription: '説明',
        },
      },
      serviceProductNumber: {
        title: 'サービスプロダクト番号',
        fieldLabels: {
          serviceProductNumber: 'サービスプロダクト番号',
          serviceProductNumberDescription: '説明',
        },
      },
      symptomCode: {
        title: '損傷コード',
        fieldLabels: {
          scGroups: '損傷コードグループ',
          symptomCode: '損傷コード',
          symptomCodeDescription: '説明',
        },
      },
      faultCode: {
        title: '故障コード',
        fieldLabels: {
          fcGroups: '故障コードグループ',
          faultCode: '故障コード',
          faultCodeDescription: '説明文',
        },
      },
      customerInformation: {
        title: '顧客情報',
        fieldLabels: {
          customerId: '顧客ID',
          customerName: '名前',
          customerAddress: '住所',
          customerContact: '連絡窓口',
          customerEmail: '電子メールアドレス',
          customerPhone: '電話番号',
        },
      },
    },
  },
  ImportJob: {
    title: 'ジョブ抽出',
    date: 'ジョブ抽出日',
    importButton: '抽出',
    searchTitle: '抽出ジョブを検索',
    searchSubtitle: '最小5文字、先行ゼロなし',
    searchButton: '探す',
    notificationNumberLabel: '通知番号',
    serviceOrderNumberLabel: '指図番号',
    linkTo: 'Link to JA',
    openJobsFoundForSerNumber: 'このシリアル番号の求人が見つかりました',
    importJobAsNew: '新規としてジョブをインポート',
    jobIsImportedAlready: 'ジョブはすでにインポートされています',
    importing: 'Importing in progress... JA',
    linking: 'Linking in progress... JA',
    columns: {
      sourceId: 'ソースID',
      notificationNumber: '通知番号',
      serviceOrderNumber: '指図番号',
      serialNumber: 'シリアル番号',
      jobTypeDescription: '説明',
      customerName: '顧客名',
    },
  },
  SingleJob: {
    title: 'ジョブ',
    createdAt: '作成日：',
    modifiedAt: '最後修正日：',
    serviceOrderNumber: '指図番号',
    notificationNumber: '通知番号',
    receivedProduct: '受入済み製品',
    productEvaluation: '製品評価',
    stripObservation: '分解観察',
    technicalInvestigation: '技術的な調査',
    conformityTest: '適合性テスト',
    log: 'ログ',
    conversation: '会話',
    noTechPossibilityParagraph1: 'このSTCには、このジョブのテスト能力がありません',
    noTechPossibilityParagraph2: 'ジョブを閉じて、ポンプを別のSTCに送ってください',
    downloadPictures: '写真をダウンロード',
    downloadAllPictures: 'すべての写真をダウンロード',
    downloadPicturesFrom: '～から画像をダウンロード',
    downloadInProgressPleaseWait: 'Download in progress... Please wait JA',
  },
  JobSummary: {
    title: 'ジョブの概要',
    createdAt: '作成日',
    modifiedAt: '最終更新日',
    reportLevelDialogTitle: 'レポートレベル',
    reportLevelDialogContent: '要求されたレポートレベルを設定する',
    rateTechnicalDecisionTitle: 'Rate technical decision JA',
    rateTechnicalDecisionComment: 'Comment on rating of technical decision JA',
    rate: 'Rate JA',
    reclassify: 'Reclassify JA',
    reportLevelDialogInitialWarrantyCodeLabel: '最初の保証',
    approveReportLevelDialogTitle: 'レポートレベルのリクエストを承認',
    technicalWarrantyDialogTitle: '技術的な決定を提案する',
    editTechnicalWarrantyDialogTitle: 'Edit technical decision proposal JA',
    technicalWarrantyDialogContent: '保証決定',
    technicalWarrantyDialogCategory: '保証カテゴリ',
    technicalWarrantyDialogSIBFieldLabel: 'SIB',
    approveTechnicalWarrantyDialogTitle: '技術保証の提案を承認する',
    approveTechnicalWarrantyDialogSIBLabel: 'SIB',
    reclassifyTechnicalWarrantyDialogTitle: '技術決定カテゴリを再分類',
    commercialDecisionDialogTitle: '商業的決定を提案する',
    commercialDecisionDialogContent: '保証決定',
    commercialDecisionDialogCategory: '保証カテゴリ',
    approveCommercialDecisionDialogTitle: '提案を承認',
    amendTechnicalWarrantyDecisionDialogTitle: 'Amend technical warranty decision JA',
    amendCommercialDecisionDialogTitle: 'Amend commercial decision JA',
    editPriceDialogTitle: '価格を編集',
    editPriceLabel: '編集',
    releaseJobDialogTitle: 'リリースジョブ',
    releaseJobDialogLabel: '方法を選択',
    proposedDate: '提案日',
    reportStatusDialogTitle: 'レポートのステータスを提案',
    reportStatusDialogContent: 'これにより、レポートの承認が要求されます。',
    approveReportStatusDialogContent: 'このジョブを再開しますか？',
    approveReportStatusDialogTitle: 'レポートのステータス',
    chooseReleaseJobMethodTitle: 'リリースジョブの方法を選択',
    editChosenReleaseJobMethodTitle: '選択したリリースジョブメソッドの編集',
    editJobStatusDialogTitle: 'ジョブステータスの編集',
    editEquipmentSerialNumberDialogTitle: '設備のシリアル番号の編集',
    editEquipmentSerialNumberDialogFieldLabel: '設備シリアル番号',
    editMaterialNumberDialogTitle: '品目番号を編集',
    editMaterialNumberDialogFieldLabel: '品目番号',
    editMaterialNumberDialogDescriptionFieldLabel: '説明',
    warrantyStartDialogTitle: '保証開始日を編集',
    warrantyStartDateLabel: '保証開始日',
    warrantyEndDialogTitle: '保証終了日を編集',
    warrantyEndDateLabel: '保証終了日',
    verifyJobDialogTitle: 'ジョブを確認',
    verifyJobDialogContent: 'この操作により、製品と設備の番号が編集用にロックされます。 次のデータは正しいですか？',
    materialNumber: '品目番号',
    equipmentSerialNumber: '設備のシリアル番号',
    deleteConfirmationDialogTitle: '確認が必要',
    deleteConfirmationDialogContent: 'このジョブを削除してもよろしいですか？',
    teamDialogTitle: 'チームメンバーを追加',
    removeTeamMemberDialogTitle: 'チームメンバーを削除',
    removeTeamMemberDialogContent: 'このメンバーをチームから削除してもよろしいですか？',
    technicalDecisionReason: '技術的決定の理由',
    warrantyExpiredSubcategoryLabel: 'Out of standard warranty period - Warranty subcategory',
    decisionReason: '決定理由',
    changeReportLevelReason: 'レポートレベルを変更する理由',
    commercialDecisionReason: '商業的判断の理由',
    approveReportLevelDialogRequestedLevel: '要求されたレベル',
    approveReportLevelDialogPreviousLevel: '前のレベル',
    approveReportLevelDialogInitialWarrantyCode: '最初の保証',
    initialWarrantyCode: '最初の保証',
    shipToAddress: '発送先',
    partNumbers: '部品番号',
    failureReason: '不具合の理由',
    symptomReason: '症状の理由',
    chooseMethod: '方法を選択',
    chosenMethod: '選ばれた方法',
    serialNumberMissingPleaseAdd: 'Serial number missing, please add. JA',
    deleteImportedJob: 'Delete imported JA',
    deleteImportedJobConfirmationDialogContent: 'Are you sure that you want to fully delete this imported job? JA',
  },
  LogSection: {
    title: 'ログ',
    sib: 'SIB',
    initialWarrantyCode: '最初の保証',
  },
  ReportsDialog: {
    title: 'レポートを生成する',
    confirmButton: '生成',
    reportFormat: 'レポート形式',
    reportTemplate: 'レポートテンプレート',
  },
  ActionMode: {
    takePicture: '写真を撮る',
    takeStandardPicture: '標準的な写真を撮る',
    takeNonStandardPicture: '非標準的な写真を撮る',
    lastScreenMessage: 'このセクションの終わりに達しました。 このウィンドウを閉じてください。',
    lastScreenMessageUnsavedAnswers: 'このセクションの終わりに達しました。 回答を保存してください。'
  },
  InputFile: {
    special: '非標準',
    upload: 'アップロードする',
    uploadStandardPicture: '標準画像をアップロード',
    uploadNonStandardPicture: '非標準の画像をアップロード',
    commentPicture: '写真のコメント',
    confirmButtonText: 'コメントを保存',
    moveFileModal: {
      title: ' ファイルを移動',
      confirmButtonText: '移動',
      selectSubsection: 'サブセクションを選択',
      selectQuestion: '質問を選択',
    },
  },
  FilePreviewModal: {
    moveFileButtonText: '移動',
  },
}



// WEBPACK FOOTER //
// ./src/constants/translations/ja.js